import {
    BackgroundCheckScreeningStatus,
    BackgroundCheckScreeningStatusDto,
} from '@clh/api-client';

const STATUS_LABELS: Record<BackgroundCheckScreeningStatus, string> = {
    NOT_STARTED: 'Not started',
    IN_PROGRESS: 'In progress',
    COMPLETE: 'Complete',
    NEEDS_REVIEW: 'Needs review',
    CANCELED: 'Canceled',
};

export function screeningStatusLabel({
    status,
    pendingStatus,
}: BackgroundCheckScreeningStatusDto): string {
    return status === BackgroundCheckScreeningStatus.InProgress && pendingStatus
        ? pendingStatus
        : STATUS_LABELS[status];
}
